const NO_TYPE = '[NO TYPE]';

export { NO_TYPE };